<template>
  <div>
    <b-skeleton-table
      v-if="fetchData"
      :rows="4"
      :columns="6"
      :table-props="{ bordered: true, striped: true }"
    >
    </b-skeleton-table>
    <div class="assessmentTools" v-else>
      <b-overlay
        :show="loadReport"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="md"
      >
        <div class="submitAssignments mb-3">
          <!-- <div class="selectReportType mb-2 d-flex justify-content-center">
            <b-form-radio v-model="reportType" :value="0"
              >Oridinary Report</b-form-radio
            >
            <b-form-radio v-model="reportType" :value="1" class="ml-3"
              >ISO Report</b-form-radio
            >
          </div> -->
          <b-row class="m-2">
            <b-button
              variant="danger"
              size="sm"
              @click="downloadAssessmentToolsReport(true, false)"
              >Save & Download Report</b-button
            >
            <b-button
              style="margin-left: 1px"
              variant="primary"
              @click="downloadAssessmentToolsReport(true, true)"
              size="sm"
              >Save & View Report
            </b-button>
          </b-row>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead class="thead-dark">
              <tr>
                <th class="align-middle"></th>
                <th
                  class="align-middle text-capitalize"
                  v-for="({ name }, coIndex) in toolsOptions"
                  :key="coIndex"
                >
                  {{ name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="({ id, code }, coIndex) in cosOptions" :key="coIndex">
                <td class="align-middle">
                  {{ code }}
                </td>
                <td
                  class="align-middle"
                  v-for="co in toolsOptions"
                  :key="co.id"
                >
                  <b-form-checkbox
                    v-model="assessmentTools[id][co.name]"
                  ></b-form-checkbox>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
export default {
  props: ["courseReport"],
  async created() {
    this.fetchData = true;
    await this.getCourseOutcomes();
    await this.getReportOptions();
    this.fetchData = false;
  },
  data() {
    return {
      fetchData: false,
      loadReport: false,
      cosOptions: [],
      toolsOptions: [
        { name: "exam" },
        { name: "assignment" },
        { name: "exitsurvey" },
        { name: "boardexam" },
      ],
      assessmentTools: {},
      reportType: 0,
      save_config: false,
    };
  },
  methods: {
    async getCourseOutcomes() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/course/${this.courseReport.course_id}/courseoutcomes`;
      await this.$axios.get(url).then((res) => {
        this.cosOptions = res.data;
        this.cosOptions.forEach(({ id }) => {
          this.$set(this.assessmentTools, id, {});
        });

        this.cosOptions.forEach(({ id }) => {
          this.toolsOptions.forEach(({ name }) => {
            this.$set(this.assessmentTools[id], name, false);
          });
        });
      });
    },

    async getReportOptions() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/courseoutcomes/assessmenttools/mapping/pdfexport`;
      await this.$axios
        .post(url, {
          course: this.courseReport.course_id,
          reportOptions: true,
        })
        .then((response) => {
          let tool_co_mapping = response.data.tool_co_mapping;
          for (const coId in tool_co_mapping) {
            const tools = tool_co_mapping[coId];
            if (coId in this.assessmentTools) {
              for (const tool in tools) {
                if (tool in this.assessmentTools[coId])
                  this.assessmentTools[coId][tool] = tools[tool];
              }
            }
          }
        })
        .catch(() => {});
    },
    async downloadAssessmentToolsReport(save_config,viewReport) {
      this.loadReport = true;
      const postData = {
        course: this.courseReport.course_id,
        tool_co_mapping: this.assessmentTools,
        save_config:save_config,
      };
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/courseoutcomes/assessmenttools/mapping/pdfexport?custom_report=${this.reportType}`;
      await this.$axios
        .post(url, postData, { responseType: "blob" })
        .then((response) => {
          const pdfBlob = new Blob([response.data], {
            type: "application/pdf",
          });
          const pdfUrl = window.URL.createObjectURL(pdfBlob);
          let newTab = null;
          if (viewReport) {
            newTab = window.open(pdfUrl, "_blank");
          }
          if (!newTab) {
            if (viewReport)
              this.$toast.error(
                "Failed to show pdf file, insted the file will be downloaded",
                {
                  position: "top",
                  duration: 3000,
                }
              );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download",`Assesment Instruments & COs-${this.courseReport.course_code}-${this.courseReport.usersubgroup_code}-${this.courseReport.usergroup_code}.pdf` )
            document.body.appendChild(link);
            link.click();
            link.remove();
          }

          // console.log(response);
        })
        .catch((error) => {
          let errorText = "Failed to Download, please check connectivity";
          if (error.response != undefined)
            errorText =
              error.response.status == 422
                ? "Custom report is not configured by admin"
                : "Failed to Download, please try again";
          this.$toast.error(errorText, {
            position: "top",
            duration: 3000,
          });
        });
      this.loadReport = false;
    },
  },
};
</script>
